import React, { useContext, useEffect, useState } from 'react'
import { Row, Button, Card, Col, Form, Input, Space, Spin, Typography } from 'antd'
import { MailOutlined, LockOutlined, LoadingOutlined } from '@ant-design/icons'
import { Login, QSLogin, HeaderHero, SEO } from './components'
import { UserContext } from '../context'
import { verifyLogin } from '../services'
import { getDomain } from '../utils'
import { useRouter } from 'next/router'
import { useApiData } from '../context/apiContext'
import { checkSelfService } from '../services/Api'

import MyAccountStyle from '../../styles/MyAccount.module.css'

const LOGIN_ERROR = 'Invalid email address or password.'
const WRONG_PASSWORD_ERROR = 'Incorrect password. Please try again.'
const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

const tabletImage = 'hero/my-account/My-Account_1024x300-no-copy.jpg'
const desktopImage = 'hero/my-account/My-Account_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/my-account/My-Account_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/my-account/My-Account_1960x300-no-copy.jpg'
const smallImage = 'hero/my-account/My-Account_375x188.jpg'
const smallImage390 = 'hero/my-account/My-Account_390x188.jpg'
const mobileImage = 'hero/my-account/My-Account_428x188.jpg'
const mobileImage768 = 'hero/my-account/My-Account_768x300-no-copy.jpg'

const { Text, Title, Link } = Typography

const MyAccount = () => {
  const router = useRouter();
  const [showLoginPage, setShowLoginPage] = useState(false)
  const [showQuickServicePage, setShowQuickServicePage] = useState(false)
  const [showMobileLoginPage, setShowMobileLoginPage] = useState(false)
  const [showMobileQuickServicePage, setShowMobileQuickServicePage] = useState(false)
  const [selectedQS, setSelectdeQS] = useState('')
  const [selectedState, setSelectedState] = useState('')
  const [loginApiResponseMessage, setLoginApiResponseMessage] = useState()
  const [qsApiResponseMessage, setQSApiResponseMessage] = useState()
  const [showSpinner, setShowSpinner] = useState(false)
  const [showSpinnerQS, setShowSpinnerQS] = useState(false)
  const [, dispatch] = useContext(UserContext)
  const [emailAddress, setEmailAddress] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMeCheck, setRememberMeCheck] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [loginMessage, setLoginMessage] = useState('')
  const [websiteMaintenanceMessage, setWebsiteMaintenanceMessage] = useState(null)
  const [websiteMaintenanceStatus, setWebsiteMaintenanceStatus] = useState(false)
  const { apiData1, apiData2 } = useApiData();

  useEffect(() => {
    if (localStorage.getItem('loginCredentials')) {
      var credentials = JSON.parse(localStorage.getItem('loginCredentials'))
      var email = credentials.emailAddress
      setEmailAddress(email)
      setRememberMeCheck(credentials.rememberMe)
    }
  }, [])

  useEffect(() => {
    if (apiData1 && apiData2) {
      function fetchWebsiteMaintainence() {
        var websiteStatusResponse = apiData1
        var websiteMessageResponse = apiData2

        const status = websiteStatusResponse?.data;
        if (status?.Result == "Active" && status?.Pages.includes("MyAccountLogin")) {
          setWebsiteMaintenanceStatus(!status.AllowAccessPages.includes("MyAccountLogin"));
          setWebsiteMaintenanceMessage(websiteMessageResponse?.data?.Result);
        } else {
          setWebsiteMaintenanceStatus(false);
          setWebsiteMaintenanceMessage(null);
        }
      }
      fetchWebsiteMaintainence()
    }
  }, [apiData1, apiData2]);

  const loginClass = showLoginPage ? 'show-login' : 'hide-login'
  const quickServiceClass = showQuickServicePage ? 'show-quick-service' : 'hide-quick-service'
  const qsClass = showLoginPage || showQuickServicePage ? 'hide-qs-service' : 'show-qs-service'

  const loginMobileClass = showMobileLoginPage ? 'show-login' : 'hide-login'
  const quickServiceMobileClass = showMobileQuickServicePage ? 'show-quick-service' : 'hide-quick-service'
  const showModalClass = showMobileLoginPage || showMobileQuickServicePage ? 'show-mobile-modal' : 'hide-mobile-modal'
  const hideModalClass =
    showMobileLoginPage || showMobileQuickServicePage ? 'hide-mobile-select-options' : 'show-mobile-select-options'

  const scrollToRef = () => {
    const ref = document.querySelectorAll('[class*="my-account-screen"]'); //getElementsByClassName('my-account-screen')
    if (ref && ref.length > 0) {
      window.scrollTo(0, ref[0].offsetTop)
    }
  }
  const executeScroll = () => scrollToRef()

  const closeLoginModal = () => {
    setShowLoginPage(false)
    setSelectedState('')
    setLoginApiResponseMessage(null)
  }

  const closeQSModal = () => {
    setShowQuickServicePage(false)
    setSelectdeQS('')
    setQSApiResponseMessage(null)
  }

  const closeMobileLoginModal = () => {
    setShowLoginPage(false)
    setShowMobileLoginPage(false)
    setSelectedState('')
  }

  const closeMobileQSModal = () => {
    setShowQuickServicePage(false)
    setShowMobileQuickServicePage(false)
    setSelectdeQS('')
  }

  const handleLogin = async (emailAddress, password) => {
    setLoginApiResponseMessage(null)
    setShowSpinner(true)
    const response = await verifyLogin(emailAddress, password, 'login')
    if (response && response.data) {
      const { Result, Tkn, Zip, PolicyNumber, Env } = response.data
      setLoginApiResponseMessage(Result)

      if (Result === 'Not Found') {
        setErrorMessage(LOGIN_ERROR)
        setLoginMessage('')
      } else if (Result === 'Error') {
        setErrorMessage(LOGIN_ERROR)
        setLoginMessage('')
      } else if (Result === "Non Converted GW User") {
        router.push(`/my-account/update?verifiedUser=${emailAddress}`)
      } else if (Result === "Policy User and Non Converted GW User") {
        setLoginApiResponseMessage(Result)
        router.push('/my-account/forgot-email')
      } else if (Result === 'Incorrect Password') {
        setErrorMessage(WRONG_PASSWORD_ERROR)
        setLoginMessage('')
      } else if (Result === 'Unable to locate policy.') {
        setErrorMessage(Result)
        setLoginMessage('')
      } else {
        setLoginMessage(Result)
        setErrorMessage('')
      }

      if (Result === 'Success') {
        // Check self service table if policy is blocked from logging in
        const selfServiceResponse = await checkSelfService(PolicyNumber, Env)
        if (selfServiceResponse?.data?.Result != null) {
          setErrorMessage(selfServiceResponse?.data?.Result)
          setLoginMessage('')
          setShowSpinner(false)
        }
        else {
          const url = `https://${getDomain('account')}/home?tkn=${Tkn}`
          window.location = url
        }
      } else if (Result === 'Loaded By Temp Password') {
        dispatch({
          type: 'ADD_EMAIL',
          payload: {
            emailAddress,
            tempPassword: password
          }
        })
        router.push({
          pathname: '/my-account/temp-password',
          query: { Result, Zip, PolicyNumber }
        })
        // window.location = '/my-account/temp-password'
      } else {
        setShowSpinner(false)
      }
    } else {
      setShowSpinner(false)
    }
  }

  const handleQSLogin = async (ssnNumber, zipCode) => {
    setQSApiResponseMessage(null)
    setShowSpinnerQS(true)
    const response = await verifyLogin(zipCode, ssnNumber, 'qs')
    if (response && response.data) {
      const { Result, Tkn, Zip, PolicyNumber, Env } = response.data
      setQSApiResponseMessage(Result)
      if (Result === 'Success') {
        const url = `https://${getDomain('account')}/quick-service?tkn=${Tkn}`
        window.location = url
      } else {
        setShowSpinnerQS(false)
      }
    } else {
      setShowSpinnerQS(false)
    }
  }

  const handleClick = () => {
    setLoginMessage('')
    setErrorMessage('')
    setShowSpinner(true)

    // Stores credentials if remember is checked
    if (rememberMeCheck) {
      localStorage.setItem('loginCredentials', JSON.stringify({ emailAddress: emailAddress, rememberMe: rememberMeCheck }))
    }
    else {
      localStorage.removeItem('loginCredentials')
    }
    handleLogin(emailAddress, password)
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleClick()
    }
  }


  return (
    <>
      <SEO
        description="Access your CURE Auto Insurance account to easily make a payment, get your ID cards, change your address, add and remove vehicles, drivers and more."
        title="My Account Login Page for NJ, PA & MI Drivers | CURE"
        url="/my-account"
      />
      <div className={`${MyAccountStyle["my-account"]}`}>
        <HeaderHero
          desktopImage={desktopImage}
          largeScreenImage={largeScreenImage}
          mobileImage={mobileImage}
          mobileImage768={mobileImage768}
          smallImage={smallImage}
          smallImage390={smallImage390}
          tabletImage={tabletImage}
          title="MY ACCOUNT"
          xtraLargeScreenImage={xtraLargeScreenImage}
          alt={"My Account - CURE auto insurance"}
          className='object-fit-unset'
        />
        <Row className={`${MyAccountStyle["my-account-screen"]} ${loginMobileClass} ${quickServiceMobileClass} page-text-margin`}>
          <Col
            lg={{ span: 12 }}
            md={{ span: 0 }}
            sm={{ span: 0 }}
            style={{ maxWidth: 610 }}
            xl={{ span: 14 }}
            xs={{ span: 0 }}
          >
            <Card bordered={false}>
              <Title className={`${MyAccountStyle["my-account-sub-title"]} ${MyAccountStyle["text-center"]}`} level={2}>
                Log In
              </Title>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-12"]}`} />
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["text-center"]} ${MyAccountStyle["subtext"]} ${MyAccountStyle["margin-left-below-login"]}`}>
                Log in to access your policy information 24/7.
              </Text>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-12"]}`} />
              <Card bordered={false} className={`${MyAccountStyle["login-class"]}`} title={''}>
                <Form>
                  <Form.Item>
                    <Input autoComplete="off" className={`${MyAccountStyle["input-text"]}`} disabled={websiteMaintenanceStatus} onChange={(event) => setEmailAddress(event.target.value)} onKeyDown={handleKeyDown} placeholder='Username or Email Address' prefix={<MailOutlined className={`${MyAccountStyle["site-form-item-icon"]}`} />} value={emailAddress} />
                  </Form.Item>
                  <Form.Item>
                    <Input.Password autoComplete="off" className={`${MyAccountStyle["input-text"]}`}
                      disabled={websiteMaintenanceStatus}
                      iconRender={visible => (visible ? 'Hide' : 'Show')}
                      onChange={(event) => setPassword(event.target.value)}
                      onKeyDown={handleKeyDown}
                      placeholder='Password'
                      prefix={<LockOutlined className={`${MyAccountStyle["site-form-item-icon"]}`} />}
                      type="password"
                      value={password}
                    />
                    {errorMessage && <div className={`${MyAccountStyle["error-message"]}`}>
                      {
                        errorMessage
                      }
                    </div>}
                    {loginMessage === 'Inactive' && <div className={`${MyAccountStyle["blue-message"]}`}>
                      Your account is inactive. Please call 800-535-2873 for assistance. If you would like to make a payment,&nbsp;
                      <a href={'https://' + getDomain('payments')} rel="noopener noreferrer" target="_blank">click here</a>
                    </div>}
                    {loginMessage !== 'Inactive' && errorMessage !== 'Invalid email address or password.' && showSpinner && <div className={`${MyAccountStyle["blue-message"]} ${MyAccountStyle["float-left"]}`}>Please wait ...</div>}
                    {loginMessage !== 'Inactive' && errorMessage !== 'Invalid email address or password.' && showSpinner && <Spin indicator={antIcon} />}
                  </Form.Item>

                  {/* Remember Me */}
                  <Row style={{ marginTop: '-2em', height: '50px', justifyContent: 'center', alignContent: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                      <input type='checkbox' id='rememberMeCheck1' style={{ alignContent: 'center' }} checked={rememberMeCheck} onChange={(e) => setRememberMeCheck(e.currentTarget.checked)} />
                      <label htmlFor='rememberMeCheck1' style={{ fontSize: '16px', clear: 'both' }}>&nbsp;&nbsp;Remember Me</label>
                    </div>
                  </Row>

                  {!websiteMaintenanceStatus && <Row className={`${MyAccountStyle["forgot-links"]}`}>
                    <a className={`${MyAccountStyle["forgot-text"]}`}>Forgot</a>
                    <Link href='/my-account/forgot-email' style={{ marginRight: 3 }}> Username / Email Address</Link>
                    <a className={`${MyAccountStyle["forgot-text"]}`}>or</a>
                    <Link href='/my-account/forgot-password' style={{ marginRight: 3 }}>Password?</Link>
                  </Row>}
                  <Form.Item className={`${MyAccountStyle["btn-control"]}`}>
                    <Space>
                      <Button className={`${MyAccountStyle["login"]} ${MyAccountStyle["login-form-button"]}`} disabled={websiteMaintenanceStatus} onClick={handleClick}>
                        Log In
                      </Button>
                    </Space>
                  </Form.Item>
                </Form>
              </Card>
              <Row className={`${MyAccountStyle["forgot-links"]} ${MyAccountStyle["create-account-container"]}`}>
                <a className={`${MyAccountStyle["forgot-text"]}`}>New user? </a>
                <Link href='/my-account/register' className={`${MyAccountStyle["account-link"]}`} style={{ marginRight: 3 }}>Create an account!</Link>
              </Row>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["subtext"]} ${MyAccountStyle["text-center"]}`} style={{ minWidth: 405 }}>
                Enroll in Autopay and paperless billing so you never miss a payment.
              </Text>
            </Card>
          </Col>
          <Col
            lg={{ span: 10, offset: 1 }}
            md={{ span: 0 }}
            sm={{ span: 0 }}
            xl={{ span: 8, offset: 2 }}
            xs={{ span: 0 }}
          >
            <Card bordered={false} className={qsClass}>
              <Title className={`${MyAccountStyle["my-account-sub-title-qs"]} ${MyAccountStyle["text-center"]}`} level={2}>
                Or, skip logging in...
              </Title>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-12"]}`} />
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-1"]} `} />
              <Row>
                {/* <Col className={`${MyAccountStyle["account-button"]} ${MyAccountStyle["express-button"]}`} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
                  <a href='/g/express-policy-changes' rel="noopener noreferrer">
                    <Button className={`${MyAccountStyle["express-changes"]} ${MyAccountStyle["text-left"]}`}><img alt="express-changes" />EXPRESS POLICY CHANGES</Button>
                  </a>
                </Col> */}
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  lg={{ span: 24 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xl={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <a
                    href={'https://' + getDomain('payments')}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Button className={`${MyAccountStyle["manage-policy"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="manage_policy" /> PAY BILL NOW
                    </Button>
                  </a>
                </Col>
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  lg={{ span: 24 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xl={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <a
                    onClick={() => {
                      setSelectedState('')
                      setSelectdeQS('Get your ID card.')
                      setShowLoginPage(false)
                      setShowMobileLoginPage(false)
                      setShowQuickServicePage(true)
                      setShowMobileQuickServicePage(false)
                    }}
                  >
                    <Button className={`${MyAccountStyle["get-id-card"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="get_id_card" /> GET ID CARD
                    </Button>
                  </a>
                </Col>
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  lg={{ span: 24 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xl={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <a
                    onClick={() => {
                      setSelectedState('')
                      setSelectdeQS('View your amount due.')
                      setShowLoginPage(false)
                      setShowQuickServicePage(true)
                      setShowMobileLoginPage(false)
                      setShowMobileQuickServicePage(false)
                    }}
                  >
                    <Button className={`${MyAccountStyle["make-payment"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="make_payment" /> VIEW AMOUNT DUE
                    </Button>
                  </a>
                </Col>
              </Row>
            </Card>
            <Col
              className={`${MyAccountStyle["margin-auto"]}`}
              lg={{ span: 24 }}
              md={{ span: 0 }}
              sm={{ span: 0 }}
              xl={{ span: 24 }}
              xs={{ span: 0 }}
            >
              <Login
                closeLoginModal={closeLoginModal}
                handleSubmit={handleLogin}
                loginClass={loginClass}
                message={loginApiResponseMessage}
                selectedState={selectedState}
                setShowSpinner={setShowSpinner}
                showSpinner={showSpinner}
              />
              <QSLogin
                closeQSModal={closeQSModal}
                handleSubmit={handleQSLogin}
                message={qsApiResponseMessage}
                quickServiceClass={quickServiceClass}
                selectedQS={selectedQS}
                setShowSpinner={setShowSpinnerQS}
                showSpinner={showSpinnerQS}
              />
            </Col>
          </Col>
          <Col lg={{ span: 0 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 0 }} xs={{ span: 24 }}>
            <Card bordered={false} className={hideModalClass}>
              <Title className={`${MyAccountStyle["my-account-sub-title"]} ${MyAccountStyle["text-center"]}`} level={2}>
                Log In
              </Title>
              <Row className={`${MyAccountStyle["forgot-links-height-0"]}`}>
                {/* <a className={`${MyAccountStyle["forgot-text"]}`}>New user? </a>
                <Link href='/my-account/register' style={{ marginRight: 3 }}>Create an account!</Link> */}
              </Row>
              <Card bordered={false} className={`${MyAccountStyle["login-class"]}`} title={''}>
                <Form>
                  <Form.Item>
                    <Input autoComplete="off" className={`${MyAccountStyle["input-text"]}`} disabled={websiteMaintenanceStatus} onChange={(event) => setEmailAddress(event.target.value)} onKeyDown={handleKeyDown} placeholder='Username or Email Address' prefix={<MailOutlined className={`${MyAccountStyle["site-form-item-icon"]}`} />} value={emailAddress} />
                  </Form.Item>
                  <Form.Item>
                    <Input.Password autoComplete="off" className={`${MyAccountStyle["input-text"]}`}
                      disabled={websiteMaintenanceStatus}
                      iconRender={visible => (visible ? 'Hide' : 'Show')}
                      onChange={(event) => setPassword(event.target.value)}
                      onKeyDown={handleKeyDown}
                      placeholder='Password'
                      prefix={<LockOutlined className={`${MyAccountStyle["site-form-item-icon"]}`} />}
                      type="password"
                      value={password}
                    />
                    {errorMessage && <div className={`${MyAccountStyle["error-message"]}`}>
                      {
                        errorMessage
                      }
                    </div>}
                    {loginMessage === 'Inactive' && <div className={`${MyAccountStyle["blue-message"]}`}>
                      Your account is inactive. Please call 800-535-2873 for assistance. If you would like to make a payment,&nbsp;
                      <a href={'https://' + getDomain('payments')} rel="noopener noreferrer" target="_blank">click here</a>
                    </div>}
                    {loginMessage !== 'Inactive' && errorMessage !== 'Invalid email address or password.' && showSpinner && <div className={`${MyAccountStyle["blue-message"]} ${MyAccountStyle["float-left"]}`}>Please wait ...</div>}
                    {loginMessage !== 'Inactive' && errorMessage !== 'Invalid email address or password.' && showSpinner && <Spin indicator={antIcon} />}
                  </Form.Item>

                  {/* Remember Me */}
                  <Row style={{ marginTop: '-2em', height: '50px', justifyContent: 'center', alignContent: 'center' }}>
                    <div style={{ display: 'flex' }}>
                      <input type='checkbox' id='rememberMeCheck2' style={{ marginTop: '5px' }} checked={rememberMeCheck} onChange={(e) => setRememberMeCheck(e.currentTarget.checked)} />
                      <label htmlFor='rememberMeCheck2' style={{ fontSize: '16px', clear: 'both' }}>&nbsp;&nbsp;Remember Me</label>
                    </div>
                  </Row>

                  {!websiteMaintenanceStatus && <Row className={`${MyAccountStyle["forgot-links"]}`}>
                    <a className={`${MyAccountStyle["forgot-text"]}`}>Forgot</a>
                    <Link href='/my-account/forgot-email' style={{ marginRight: 3 }}> Username / Email Address</Link>
                    <a className={`${MyAccountStyle["forgot-text"]}`}>or</a>
                    <Link href='/my-account/forgot-password' style={{ marginRight: 3 }}>Password?</Link>
                  </Row>}
                  <Form.Item className={`${MyAccountStyle["btn-control"]}`}>
                    <Space>
                      <Button className={`${MyAccountStyle["login"]} ${MyAccountStyle["login-form-button"]}`} disabled={websiteMaintenanceStatus} onClick={handleClick}>
                        Log In
                      </Button>
                    </Space>
                  </Form.Item>
                </Form>
              </Card>
              <Row className={`${MyAccountStyle["forgot-links"]} ${MyAccountStyle["create-account-container"]}`}>
                <a className={`${MyAccountStyle["forgot-text"]}`}>New user? </a>
                <Link href='/my-account/register' className={`${MyAccountStyle["account-link"]}`} style={{ marginRight: 3 }}>Create an account!</Link>
              </Row>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["subtext"]} ${MyAccountStyle["text-center"]}`}>
                Enroll in Autopay and paperless billing so you never miss a payment.
              </Text>
            </Card>
          </Col>
          <Col lg={{ span: 0 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 0 }} xs={{ span: 24 }}>
            <Card bordered={false} className={`${hideModalClass} bg-color-blue`}>
              <Title className={`${MyAccountStyle["my-account-sub-title-qs"]} ${MyAccountStyle["text-center"]} ${MyAccountStyle["margin-0"]}`} level={2}>
                Or, skip logging in...
              </Title>
              <Text className={`${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-12"]} ${MyAccountStyle["margin-bottom-12"]}`} />
              <Text className={`${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-1"]} ${MyAccountStyle["margin-bottom-12"]}`} />
              <Row>
                {/* <Col className={`${MyAccountStyle["account-button"]} ${MyAccountStyle["express-button"]} `} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
                  <a href='/g/express-policy-changes' rel="noopener noreferrer">
                    <Button className={`${MyAccountStyle["express-changes"]} ${MyAccountStyle["text-left"]} `}><img alt="express-changes" />EXPRESS POLICY CHANGES</Button>
                  </a>
                </Col> */}
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  lg={{ span: 24 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xl={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <a
                    href={'https://' + getDomain('payments')}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Button className={`${MyAccountStyle["manage-policy"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="manage_policy" /> PAY BILL NOW
                    </Button>
                  </a>
                </Col>
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  lg={{ span: 24 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xl={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <a
                    onClick={() => {
                      executeScroll()
                      setSelectedState('')
                      setSelectdeQS('Get your ID card.')
                      setShowMobileLoginPage(false)
                      setShowMobileQuickServicePage(true)
                    }}
                  >
                    <Button className={`${MyAccountStyle["get-id-card"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="get_id_card" /> GET ID CARD
                    </Button>
                  </a>
                </Col>
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  lg={{ span: 24 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xl={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <a
                    onClick={() => {
                      executeScroll()
                      setSelectedState('')
                      setSelectdeQS('View your amount due.')
                      setShowMobileLoginPage(false)
                      setShowMobileQuickServicePage(true)
                    }}
                  >
                    <Button className={`${MyAccountStyle["make-payment"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="make_payment" /> VIEW AMOUNT DUE
                    </Button>
                  </a>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col
            className={`${MyAccountStyle["margin-auto"]} ${showModalClass}`}
            lg={{ span: 0 }}
            md={{ span: 24 }}
            sm={{ span: 24 }}
            xl={{ span: 0 }}
            xs={{ span: 24 }}
          >
            <Login
              closeLoginModal={closeMobileLoginModal}
              handleSubmit={handleLogin}
              loginClass={loginMobileClass}
              message={loginApiResponseMessage}
              selectedState={selectedState}
              setShowSpinner={setShowSpinner}
              showSpinner={showSpinner}
            />
            <QSLogin
              closeQSModal={closeMobileQSModal}
              handleSubmit={handleQSLogin}
              message={qsApiResponseMessage}
              quickServiceClass={quickServiceMobileClass}
              selectedQS={selectedQS}
              setShowSpinner={setShowSpinner}
              showSpinner={showSpinner}
            />
            {selectedQS && selectedQS.length > 0 && (
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["subtext"]} ${MyAccountStyle["margin-left-0"]}`}>
                Michigan drivers please{' '}
                <a className={`${MyAccountStyle["text-underline"]}`} href="https://accounts.cure.com" rel="noreferrer" target="_blank">
                  click here
                </a>
                .
              </Text>
            )}
          </Col>
        </Row>
      </div>
    </>
  )
}

MyAccount.propTypes = {}

export default MyAccount
